module.exports = __webpack_public_path__ + "static/media/19.4148eb90.jpg";